import { inject, Injectable } from "@angular/core";
import { CareHomesService } from "../../shared/care-homes/care-homes.service";
import { IEmployee, IExtendedEmployee } from "./employee.model";

@Injectable({
  providedIn: "root",
})
export class EmployeeUtilsService {
  private careHomeService = inject(CareHomesService);

  get currentCareHomeId(): number {
    return this.careHomeService.currentCareHome.careHomeId;
  }

  isEmployeeSecondedToThisCareHome(employee: { secondedCareHomeId: number }) {
    return (
      this.isEmployeeSeconded(employee) &&
      this.currentCareHomeId === employee.secondedCareHomeId
    );
  }

  isEmployeeOutsideThisCareHome(employee: { secondedCareHomeId: number }) {
    return (
      this.isEmployeeSeconded(employee) &&
      this.currentCareHomeId !== employee.secondedCareHomeId
    );
  }

  isEmployeeSeconded(employee: { secondedCareHomeId: number }) {
    return !!employee.secondedCareHomeId;
  }

  isEmployeeSecondedRota(
    employee: {
      secondedCareHomeId: number;
      secondedDateStart: string;
      secondedDateEnd: string;
    },
    day: { scheduleDate: string }
  ) {
    const scheduleDate = new Date(day.scheduleDate);
    const startDate = new Date(employee.secondedDateStart);
    const endDate = new Date(employee.secondedDateEnd);

    const normalizeDate = (date: Date) =>
      new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const normalizedScheduleDate = normalizeDate(scheduleDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    return (
      !!employee.secondedCareHomeId &&
      normalizedScheduleDate >= normalizedStartDate &&
      normalizedScheduleDate <= normalizedEndDate
    );
  }

  extendEmployee<T extends { secondedCareHomeId: number }>(
    employee: T
  ): T & IEmployeeSecondedExtension {
    return {
      ...employee,
      isEmployeeSeconded: this.isEmployeeSeconded(employee),
      isEmployeeSecondedToThisCareHome:
        this.isEmployeeSecondedToThisCareHome(employee),
      isEmployeeOutsideThisCareHome:
        this.isEmployeeOutsideThisCareHome(employee),
    };
  }

  mapExtendEmployee<T extends { secondedCareHomeId: number }>(
    employees: T[]
  ): (T & IEmployeeSecondedExtension)[] {
    console.log(employees.map((employee) => this.extendEmployee<T>(employee)));

    return employees.map((employee) => this.extendEmployee<T>(employee));
  }

  static rowClassInside = (row: any & IEmployeeSecondedExtension) => {
    if (row.isEmployeeSeconded && row.isEmployeeSecondedToThisCareHome) {
      return "row-greyed-out";
    }
    return "";
  };

  static rowClassOutside = (row: any & IEmployeeSecondedExtension) => {
    if (row.isEmployeeSeconded && row.isEmployeeOutsideThisCareHome) {
      return "row-greyed-out";
    }
    return "";
  };
}

export interface IEmployeeSecondedExtension {
  isEmployeeSeconded: boolean;
  isEmployeeSecondedToThisCareHome: boolean;
  isEmployeeOutsideThisCareHome: boolean;
}
